import { useTranslation } from "react-i18next";
import { HeroSection } from "@/components/home/HeroSection";
import { LogoTicker } from "@/components/shared/LogoTicker";
import { SegmentsSection } from "@/components/home/SegmentsSection";
import { ProblemsSection } from "@/components/home/ProblemsSection";
import { SolutionsSection } from "@/components/home/SolutionsSection";
import { ProductsSection } from "@/components/home/ProductsSection";
import { SocialProofSection } from "@/components/home/SocialProofSection";
import { CTASection } from "@/components/home/CTASection";
import { PageSEO } from "@/components/seo/PageSEO";

const Index = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageSEO description={t("seo.home")} />
      <HeroSection />
      <LogoTicker title={t("socialProof.logoTitle")} />
      <SegmentsSection />
      <ProblemsSection />
      <SolutionsSection />
      <ProductsSection />
      <SocialProofSection />
      <CTASection />
    </>
  );
};

export default Index;
